import { Form, Formik, FormikValues } from 'formik';
import React, { useEffect, useRef } from 'react';
import * as Yup from 'yup';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle
} from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';

import FormikButton from '../../../common/formik/FormikButton';
import FormikGrid from '../../../common/formik/FormikGrid';
import FormikTextField from '../../../common/formik/FormikTextField';
import { ProductComponent } from '../Product.interface';
import {
  useCreateProductComponent,
  useUpdateProductComponent
} from '../Product.hooks';

export interface CreateEditProductComponentDialogProps {
  open: boolean;
  productId: number;
  productComponent?: ProductComponent | null;
  onCancel?: () => void;
  onSubmit?: (productComponent: ProductComponent) => void;
}

const CreateEditProductComponentDialog: React.FC<CreateEditProductComponentDialogProps> = ({
  open,
  productComponent,
  productId,
  onCancel,
  onSubmit
}) => {
  const formikRef = useRef<FormikValues>();
  const onSubmitRef = useRef(onSubmit);
  const {
    createdComponent,
    createComponentError,
    createComponent
  } = useCreateProductComponent(productId);
  const {
    updatedComponent,
    updateComponentError,
    updateComponent
  } = useUpdateProductComponent(productId, productComponent?.id || 0);

  useEffect(() => {
    if (createdComponent) {
      onSubmitRef.current?.(createdComponent);
    }
    formikRef.current?.setSubmitting(false);
  }, [createdComponent]);
  useEffect(() => {
    if (updatedComponent) {
      onSubmitRef.current?.(updatedComponent);
    }
    formikRef.current?.setSubmitting(false);
  }, [updatedComponent]);

  return (
    <Dialog maxWidth='xs' open={open} onClose={onCancel}>
      <Formik
        innerRef={(formik: any) => (formikRef.current = formik)}
        initialValues={{ name: productComponent?.name || '' }}
        validationSchema={Yup.object({
          name: Yup.string().required('Required')
        })}
        onSubmit={(form: any) => {
          if (productComponent) {
            updateComponent({ id: productComponent.id, ...form });
          } else {
            createComponent(form);
          }
        }}
      >
        <Form autoComplete='off'>
          <DialogTitle>
            {productComponent ? 'Update' : 'Create'} Product Component
          </DialogTitle>
          <DialogContent>
            <FormikGrid>
              <FormikTextField
                autoFocus
                type='text'
                name='name'
                label='Component Name'
              />
            </FormikGrid>
            {createComponentError && (
              <Alert severity='error'>{`Error occurred. ${createComponentError.message}`}</Alert>
            )}
            {updateComponentError && (
              <Alert severity='error'>{`Error occurred. ${updateComponentError.message}`}</Alert>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={onCancel}>Cancel</Button>
            <FormikButton>
              {productComponent ? 'Update' : 'Create'}
            </FormikButton>
          </DialogActions>
        </Form>
      </Formik>
    </Dialog>
  );
};

export default CreateEditProductComponentDialog;
